import { BaseModel } from "../base-model";

export interface ITaskModel {
    Alarm?: boolean;
    AttachAType?: number;
    AttachBType?: number;
    Comment?: string;
    CreatedDate?: string;
    CreatedUserId?: number;
    Date?: string;
    DemandId?: number;
    DemandRef?: string;
    Description?: string;
    Duration?: number;
    DurationAlarm?: number;
    Email?: string;
    EmailConfirm?: number;
    EntryId?: string;
    Id?: number;
    IsDeleted?: boolean;
    IsDone?: boolean;
    IsExcludeFromReport?: boolean;
    IsTouched?: boolean;
    MainMessageType?: number;
    ModifiedDate?: string;
    ModifiedUserId?: number;
    ObjectId?: number;
    ObjectRef?: string;
    OrigId?: number;
    OriginContactId?: number;
    ParentTaskId?: number;
    PersonId?: number;
    PersonRef?: string;
    PrintId?: number;
    RecurrenceId?: number;
    RecurrencePatternInfo?: string;
    Sent?: boolean;
    StartTime?: string;
    Status?: number;
    Subject?: string;
    TaskCode?: number;
    TypeId?: number;
    UserId?: number;
    CheckingConfictData?: string;
}
export class TaskModel  extends BaseModel<ITaskModel>{
    Alarm?: boolean;
    AttachAType?: number;
    AttachBType?: number;
    Comment?: string;
    CreatedDate?: string;
    CreatedUserId?: number;
    Date?: string;
    DemandId?: number;
    DemandRef?: string;
    Description?: string;
    Duration?: number;
    DurationAlarm?: number;
    Email?: string;
    EmailConfirm?: number;
    EntryId?: string;
    Id?: number;
    IsDeleted?: boolean;
    IsDone?: boolean;
    IsExcludeFromReport?: boolean;
    IsTouched?: boolean;
    MainMessageType?: number;
    ModifiedDate?: string;
    ModifiedUserId?: number;
    ObjectId?: number;
    ObjectRef?: string;
    OrigId?: number;
    OriginContactId?: number;
    ParentTaskId?: number;
    PersonId?: number;
    PersonRef?: string;
    PrintId?: number;
    RecurrenceId?: number;
    RecurrencePatternInfo?: string;
    Sent?: boolean;
    StartTime?: string;
    Status?: number;
    Subject?: string;
    TaskCode?: number;
    TypeId?: number;
    UserId?: number;
    CheckingConfictData?: string;

    constructor(option?: TaskModel) {
        super(option);
        this.TypeId = this.TypeId|| null;
        this.UserId = this.UserId|| null;
        this.Date = this.Date|| new Date(Date.now()).toDateString();
        this.CreatedDate = this.Date;
        this.CreatedUserId = this.CreatedUserId|| null;
        this.ModifiedDate = this.Date;
        this.ModifiedUserId = this.ModifiedUserId|| null;
        this.IsDone = this.IsDone|| false;
        this.IsExcludeFromReport = this.IsExcludeFromReport|| false;
        this.IsTouched = this.IsTouched|| false;
        this.Comment = this.Comment|| null;
        this.Description = this.Description|| null;
        this.PersonId = this.PersonId|| null;
        this.DemandId = this.DemandId|| null;
        this.ObjectId = this.ObjectId || null;
        this.CheckingConfictData = this.CheckingConfictData || null;
    }
}

/**
 * Fields a caller can seed a brand-new task with when no route query is available
 * (drawer flows). Applied to the init response before the model/origin commits,
 * so a seeded form still counts as untouched (FRO-11391).
 *
 * The set is everything the General tab lets a user set, minus Date and IsDone.
 * Narrower than the WinApp's "Copy task" (immo UCAgenda.TaskAndChecklist.cs
 * CreateCopyTask, which keeps both): a follow-up exists to be done later, so its
 * date and open state start fresh.
 */
export const TASK_PREFILL_FIELDS = [
    'ObjectId', 'ObjectRef',
    'PersonId', 'PersonRef',
    'DemandId', 'DemandRef',
    'UserId', 'TypeId', 'Subject', 'Comment', 'OriginContactId', 'IsExcludeFromReport'
] as const;

export type ITaskPrefill = Partial<Pick<ITaskModel, typeof TASK_PREFILL_FIELDS[number]>>;
